jQuery(document).ready(function($) {
    //If the user is on login, remove the cookie
    const current_uri = window.location.toString().split('/')[window.location.toString().split('/').length - 1].length > 0 ? window.location.toString().split('/')[window.location.toString().split('/').length - 1] : window.location.toString().split('/')[window.location.toString().split('/').length - 2];

    // get current path without domain
    const current_path = window.location.pathname;

    if(
        current_path === "/login" ||
        current_path === "/firstUse" ||
        current_uri === "reset" ||
        current_uri.split('?email=').length > 1 ||
        window.location.toString().split('/apply/').length > 1 ||
        window.location.toString().split('/evaluations/submit/').length > 1 ||
        window.location.toString().split('/evaluations/student/').length > 1 ||
        window.location.toString().split('/digital-presence').length > 1 ||
        window.location.toString().split('/remote-support').length > 1
    ) {
        setCookie('current_user', null, -1);
    } else {
        $.get('/ajax/getCurrentUser', function(data) {
            setCookie("current_user", data);
            checkTerms();
        });
    }
});
function get_current_user() {
    return getCookie("current_user");
}
function this_user_has_role(role) {
    var u = get_current_user();
    for(var key in u.roles) {
        if(isNaN(role)) {
            return u.roles[key] == role;
        } else {
            return key == role;
        }
    }
}
function this_user_has_roles(roles) {
    var answer = false;
    for(var i in roles) {
        var role = roles[i];
        if(this_user_has_role(role) === true) {
            answer = true;
            break;
        }
    }
    return answer;
}
function get_user_meta(key, callback, ifnull) {
    var $ = jQuery.noConflict();
    $.get('/ajax/getCurrentUserMeta/'+key, function(data) {
        if(data.length == 0) {
            if(ifnull == undefined) {
                ifnull = null;
            }
            data = ifnull;
        }
        callback(data);
    });
}
function set_user_meta(key, value, callback) {
    var $ = jQuery.noConflict();
    $.get('/ajax/setCurrentUserMeta/'+key+'/'+value, function(data) {
        if(callback != undefined) {
            callback(data);
        }
    });
}
